import { useAuthUserData, useUpdateAuthUserData } from '../../../authUserProvider'
import { useBranding } from '../../../branding/useBranding'
import styles from './styles.module.scss'

/**
 * Mobile top bar: brand logo, hamburger that opens the sidebar drawer, and the
 * signed-in user's initial. Hidden on desktop where the sidebar is always
 * visible. Mounted once by containers/main.tsx.
 */
function AppTopBar() {
    const authUser = useAuthUserData()
    const updateAuthUser = useUpdateAuthUserData()
    const brand = useBranding()
    const open = Boolean(authUser?.sidebar)
    const initial = String(authUser?.name ?? '').trim().charAt(0)

    const toggleSidebar = () => {
        updateAuthUser({ ...authUser, sidebar: !open })
    }

    return (
        <header className={styles.topBar}>
            <div className={styles.left}>
                <button
                    type="button"
                    className={`${styles.menuButton} ${open ? styles.open : ''}`}
                    onClick={toggleSidebar}
                    aria-label={open ? 'Close menu' : 'Open menu'}
                    aria-expanded={open}
                >
                    <span />
                    <span />
                    <span />
                </button>
                <img src={brand.logo} alt={brand.logoAlt} className={styles.logo} />
            </div>
            <div className={styles.right}>
                {initial && (
                    <span className={styles.avatar} aria-hidden="true">
                        {initial}
                    </span>
                )}
            </div>
        </header>
    )
}

export default AppTopBar
export { AppTopBar as Header }
